import { render, staticRenderFns } from "./voted.vue?vue&type=template&id=8d87ed16&scoped=true&"
import script from "./voted.vue?vue&type=script&lang=js&"
export * from "./voted.vue?vue&type=script&lang=js&"
import style0 from "./voted.vue?vue&type=style&index=0&id=8d87ed16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d87ed16",
  null
  
)

export default component.exports